import { Component, OnInit, ViewChild, forwardRef } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { AdjustmentModel } from 'src/app/models/adjustment.model';
import { AdjustmentService } from 'src/app/services/adjustment.service';
import { AdjustmentCategoryService } from 'src/app/services/adjustmentCategory.service';
import { AdjustmentCategoryTypeService } from 'src/app/services/adjustmentCategoryType.service';
import { MasterMappingHeadersService } from 'src/app/services/masterMappingHeaders.service';
import { AccountService } from './../../../services/account.service';
import { LegalEntityService } from './../../../services/legalentity-service';
import { PeriodService } from './../../../services/period.service';
import { Sharedservice } from './../../../shared-components/shared.service';
import { AdjustmentCategoryModel } from 'src/app/models/adjustmentCategory.model';
import { AdjustmentCategoryTypeModel } from 'src/app/models/adjustmentCategoryType.model';
import { MasterMappingHeadersModel } from 'src/app/models/masterMappingHeaders.model';
import { AccountModel } from 'src/app/models/account.model';
import { EntityModel } from 'src/app/models/legalentity-model';
import { PeriodModel } from 'src/app/models/period.model';
import { forkJoin } from 'rxjs';
import { AdjustmentAccountPeriodModel } from '../../../models/adjustmentAccountPeriod.model';
import { UserService } from '../../../services/user.service';
import { UserModel } from '../../../models/user.model';
import { severitymessage, AddEditadjustmentComponentmessage, LanguageConstants } from '../../../shared-components/constant';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { formatNumber } from '@angular/common';
import { LanguageHelperService } from 'src/app/services/language.helper.service';

@Component({
  standalone: false,
  selector: 'app-addadjustment',
  templateUrl: './addadjustment.component.html',
  styleUrls: ['./addadjustment.component.css']
})
export class AddEditadjustmentComponent implements OnInit {
  public saveClicked = false;
  public updateClicked = false;
  public isEditAdjustment = false;
  public adjustment: AdjustmentModel = new AdjustmentModel;
  public entities1: EntityModel[];
  public entities2: EntityModel[];
  public accounts: AccountModel[] = [];
  public adjustmentCategories: AdjustmentCategoryModel[];
  public adjustmentCategoryTypes: AdjustmentCategoryTypeModel[];
  public masterMappingHeaders: MasterMappingHeadersModel[];
  public periods: PeriodModel[] = [];
  private selectedPeriodIds = '';
  private loggedInUserId: number;
  // public selectedPeriods: PeriodModel[] = [];
  id = +this.route.snapshot.paramMap.get('id');
  engagementId = +this.route.snapshot.paramMap.get('engagementid');
  selectedEngagementAdjustment: AdjustmentAccountPeriodModel[];
  cols: any[];
  changedAmount: number;
  preLoadedEntity2: EntityModel[];
  loadspinner = false;
  @ViewChild('formaddadjustment', { static: true }) form: any;
  uniqueId = 0;
  currLangTranslation: any;
  langCode: string;

  constructor(private messageService: MessageService, private adjustmentService: AdjustmentService
    , private legalEntityService: LegalEntityService, private AdjustmentCategoryTypeService: AdjustmentCategoryTypeService
    , private AdjustmentCategoryService: AdjustmentCategoryService, private MasterMappingHeadersService: MasterMappingHeadersService,
    private accountService: AccountService
    , private periodService: PeriodService, private router: Router, private route: ActivatedRoute
    , private userService: UserService, private sharedService: Sharedservice, private translateService: TranslateService,
    private languageHelper: LanguageHelperService
  ) {

  }

  ngOnInit() {
    this.messageService.clear('myKey1');
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];
    // forkJoin(this.legalEntityService.getEntities(this.engagementId),this.MasterMappingHeadersService.getMasterMappingHeaders()
    // ,this.AdjustmentCategoryService.getAdjustmentCategories(),this.AdjustmentCategoryTypeService.getAdjustmentCategoryTypes()
    // ,this.periodService.getEngagementPeriods(this.engagementId))
    // .subscribe(response => {
    //   this.entities = response[0];
    //   this.masterMappingHeaders = response[1];
    //   this.adjustmentCategories = response[2];
    //   this.adjustmentCategoryTypes = response[3];
    //   this.periods = response[4];
  //   this.intializeAdjustmentModel();
    // });
    this.sharedService.CheckUserAccessForEngagement(this.engagementId);
    this.getMapping();
    this.getCategory();
    this.getType();
    this.getPeriod();

    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData.Id !== undefined) {
        this.loggedInUserId = userData.Id;
      }
      this.getEntity();
    });

    this.cols = [
      { field: 'AdjustmentId', header: 'AdjustmentId' },
      { field: 'AccountName', header: 'Account' },
      { field: 'Period', header: 'Period' },
      { field: 'Amount', header: 'Amount' }
    ];

    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.langCode = langEvent.lang;
      this.currLangTranslation = langEvent.translations;
      this.getPeriod(true);
      this.getAccount(true);
    });
  }

  private intializeAdjustmentModel() {
    this.adjustment = {
      id: 0,
      engagementId: this.engagementId,
      entityId: null,
      mappingId: null,
      adjustmentCategoryId: null,
      adjustmentTypeId: null,
      modifiedById: this.loggedInUserId,
      adjustmentName: '',
      periods: null,
      adjustmentAccountPeriods: [],
      entityId2: null
    };

  }

  private getEntity(): void {
    this.legalEntityService.getEntities(this.engagementId).subscribe((data: EntityModel[]) => {
      // else {
      this.intializeAdjustmentModel();
      // }

      this.entities1 = [];
      this.entities1 = data.filter(entity => entity.entityLevel === 1);

      this.preLoadedEntity2 = [];
      this.preLoadedEntity2 = data.filter(entity => entity.entityLevel === 2);
    });
  }

  private getFormattedNumber(plainNumber: any, langCode: string) {
    let isNegative = false;
    if (!isNaN(plainNumber)) {
      if (plainNumber && plainNumber !== '-') {
        isNegative = !(+plainNumber > 0);
        plainNumber = formatNumber(plainNumber, langCode, '1.2-2');
      }
      if (!isNegative)
        return plainNumber;
      else
        return `(${+plainNumber * -1})`;
    }
    else
      return plainNumber;

  }

  private getMapping(): void {
    this.MasterMappingHeadersService.getMasterMappingHeaders().subscribe((data: MasterMappingHeadersModel[]) => {
      this.masterMappingHeaders = data;
    });
  }

  private getCategory(): void {
    this.AdjustmentCategoryService.getAdjustmentCategories().subscribe((data: AdjustmentCategoryModel[]) => {
      this.adjustmentCategories = data;
    });
  }

  private getType(): void {
    this.AdjustmentCategoryTypeService.getAdjustmentCategoryTypes().subscribe((data: AdjustmentCategoryTypeModel[]) => {
      this.adjustmentCategoryTypes = data;
    });
  }

  private getPeriod(isLangChange: boolean = false): void {
    this.periodService.getEngagementPeriods(this.engagementId).subscribe((data: PeriodModel[]) => {
      this.periods = data;

      this.periods.forEach(element => {
        const month = element.MonthYear.substring(0,3); 
        element.MonthYearTranslated = this.languageHelper.convertMonthToLocale(this.langCode, month) + element.MonthYear.substring(3, element.MonthYear.length);
      });

      if (this.id > 0) {
        this.isEditAdjustment = true;
        this.getAdjustmentForEdit();
      }

      if(isLangChange){
        this.adjustment.adjustmentAccountPeriods.forEach(element2 =>{
          const month = element2.Period.substring(0,3); 
          element2.PeriodTranslated = this.languageHelper.convertMonthToLocale(this.langCode, month) + element2.Period.substring(3, element2.Period.length);
          element2.AccountNameTranslated = this.adjustment.mappingId === 8 ? this.currLangTranslation.stdMappings[element2.AccountName] : element2.AccountName;
        });

        this.adjustment.periods.forEach(element3 =>{
          const month = element3.MonthYear.substring(0,3); 
          element3.MonthYearTranslated = this.languageHelper.convertMonthToLocale(this.langCode, month) + element3.MonthYear.substring(3, element3.MonthYear.length);
        });
      }

    });
  }

  private getAccount(isLangChange: boolean = false): void {

    if (this.adjustment.entityId != null && this.adjustment.entityId.length > 0 && this.adjustment.mappingId != null) {
      this.accountService.getAllAccounts(this.adjustment.entityId, this.adjustment.engagementId, this.adjustment.mappingId,
        this.adjustment.entityId2).subscribe((data: AccountModel[]) => {
          this.accounts = data;

          if(this.adjustment.mappingId === 8){
            this.accounts.forEach(element => {
              element.label = this.currLangTranslation.stdMappings[element.value];
            });

            if(isLangChange)
            {
              this.adjustment.AccData.forEach(element => {
                element.label = this.currLangTranslation.stdMappings[element.value];
              });    
            }        
          }

          if (this.id > 0) {
            this.adjustment.AccData = [];
            this.adjustment.adjustmentAccountPeriods.forEach(y => {
              y.AccountNameTranslated = this.adjustment.mappingId === 8 ? this.currLangTranslation.stdMappings[y.AccountName] : y.AccountName;
              if (this.adjustment.AccData.find(x => x.value === y.AccountName) == null) {
                const accObj: AccountModel = { value: y.AccountName, label: y.AccountNameTranslated };
                this.adjustment.AccData.push(accObj);
              }
            });
          }
        });
    }
  }

  private getAdjustmentForEdit() {
    this.loadspinner = true;

    this.adjustmentService.getAdjustment(this.id)
      .subscribe((data: AdjustmentModel) => {
        this.adjustment = data;
        this.adjustmentService.getAdjustmentAccountPeriod(this.id, this.engagementId).subscribe((data1: AdjustmentAccountPeriodModel[]) => {
          
          this.adjustment.adjustmentAccountPeriods = data1;
          this.adjustment.periods = [];

          data1.forEach(y => {
            const month = y.Period.substring(0,3); 
            y.PeriodTranslated = this.languageHelper.convertMonthToLocale(this.langCode, month) + y.Period.substring(3, y.Period.length);
            y.AccountNameTranslated = this.adjustment.mappingId === 8 ? this.currLangTranslation.stdMappings[y.AccountName] : y.AccountName;
            //this.adjustment.adjustmentAccountPeriods.Amount.
            if (this.adjustment.periods.find(x => x.Id === y.PeriodId) == null) {
              this.adjustment.periods.push(this.periods.find(x => x.Id === y.PeriodId));
            }
          });
          const uniqueBusinessSeg1Ids = data1.filter((obj, pos, arr) => {
            return arr.map(mapObj => mapObj['EntityId1']).indexOf(obj['EntityId1']) === pos;
          }).map(en => en.EntityId1);

          const uniqueBusinessSeg2Ids = data1.filter((obj, pos, arr) => {
            return arr.map(mapObj => mapObj['EntityId2']).indexOf(obj['EntityId2']) === pos;
          }).map(en => en.EntityId2);

          this.adjustment.entityId = this.entities1.filter(function (entity) {
            return uniqueBusinessSeg1Ids.includes(entity.id);
          });
          this.loadBusinessSegment2(this.adjustment.entityId);
          this.adjustment.entityId2 = this.entities2.filter(function (entity) {
            return uniqueBusinessSeg2Ids.includes(entity.id);
          });

          this.loadspinner = false;

          this.getAccount();
          // period ids for getting accounts
          // this.selectedPeriodIds = this.adjustment.periods.map(function (val) {
          //   return val.Id;
          // }).join(',');
          // this.getAccount();
        });
      }, error => {
        this.loadspinner = false;
      });
  }

  saveAdjustment() {
    if (this.form.valid) {
      this.loadspinner = true;
      this.saveClicked = true;

      this.adjustmentService.save(this.adjustment).subscribe((response: any) => {
        this.loadspinner = false;

        if (response.message === severitymessage.success) {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.addEditadjustmentComponentmessage.successMessage.addAdjustment,
            sticky: true, closable: true
          });
          setTimeout(() => {
            this.router.navigate(['/engagement/', this.engagementId, 'selectadjustment']);
          }, 2000)
        } else {
          this.saveClicked = false;
          if (response.message === severitymessage.DuplicateAddAdjustmentnames) {
            this.messageService.add({
              key: severitymessage.key, severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.DuplicateAddAdjustmentnames,
              sticky: true, closable: true
            });
          } else {
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.somethingwrong,
              sticky: true, closable: true
            });
          }


        }
      },
        error => {
          let errMessage = ''

          if (error.error?.errorid === 1) {
            errMessage = this.currLangTranslation.commonMessages.message1;
          }
          else {
            errMessage = error.error.message;
          }

          this.loadspinner = false;
          this.saveClicked = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: errMessage,
            sticky: true, closable: true
          });
        }

      );
    }
  }

  updateAdjustment() {
    if (this.form.valid) {
      this.loadspinner = true;
      this.updateClicked = true;
      this.adjustment.modifiedById = this.loggedInUserId;
      this.adjustmentService.update(this.adjustment).subscribe((response: any) => {
        this.loadspinner = false;
        if (response.message === severitymessage.success) {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.UpdatedAdjustment,
            sticky: true, closable: true
          });

          setTimeout(() => {
            this.router.navigate(['/engagement/', this.engagementId, 'selectadjustment']);
          }, 2000)
        } else {
          this.updateClicked = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true, closable: true
          });
        }
      },
        error => {
          let errMessage = ''
          if (error.error?.errorid === 1) {
            errMessage = this.currLangTranslation.commonMessages.message1;
          }
          else {
            errMessage = error.error.message;
          }
          this.loadspinner = false;
          this.updateClicked = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: errMessage,
            sticky: true, closable: true
          });
        }
      );
    }
  }

  onChange(newValue: any) {
    this.adjustment.AccData = null;
    this.adjustment.adjustmentAccountPeriods = [];
    this.getAccount();
  }

  loadBusinessSegment2(newValue) {
    this.entities2 = [];
    this.adjustment.entityId2 = [];
    const selectedEntityIds: number[] = newValue.map(p => p.id);
    this.entities2 = this.preLoadedEntity2.filter(entity => entity.entityLevel === 2 && selectedEntityIds.includes(entity.parentEntityId));
    this.adjustment.entityId2 = this.entities2;
  }

  onPeriodSelect(event) {
    this.adjustment.periods.forEach(element =>{
      const month = element.MonthYear.substring(0,3); 
          element.MonthYearTranslated = this.languageHelper.convertMonthToLocale(this.langCode, month) + element.MonthYear.substring(3, element.MonthYear.length);
    });

    this.adjustment.periods = event;
    this.selectedPeriodIds = event.map(function (val) {
      return val.Id;
    }).join(',');

    // this.adjustment.Accounts = null;
    this.adjustment.adjustmentAccountPeriods = [];
    this.onAccountSelect(this.adjustment.AccData);
    // this.getAccount();
  }

  onAccountSelect(event) {
    const adjustmentAccountPeriods: AdjustmentAccountPeriodModel[] = [];
    // filter unselect accounts
    if (this.adjustment.adjustmentAccountPeriods != null) {
      if (this.adjustment.adjustmentAccountPeriods.length > event.length) {
        this.adjustment.adjustmentAccountPeriods.forEach((x, index) => {
          x.AccountNameTranslated = this.adjustment.mappingId === 8 ? this.currLangTranslation.stdMappings[x.AccountName] : x.AccountName;
          if (event.filter(w => w.value === x.AccountName).length > 0) {            
            adjustmentAccountPeriods.push(x);
          }
        });
      }
    }

    if (adjustmentAccountPeriods.length > 0) {
      this.adjustment.adjustmentAccountPeriods = adjustmentAccountPeriods;
    }

    event.forEach(element => {

      if (this.adjustment.periods) {
        this.adjustment.periods.forEach(period => {
          if (this.adjustment.adjustmentAccountPeriods.filter(w => w.AccountName === element.value &&
            w.PeriodId === period.Id).length === 0) {

            this.adjustment.entityId2.forEach(entity2 => {
              this.adjustment.adjustmentAccountPeriods.push(this.getNewAdjustmentAccountPeriodModel(element, period, null, entity2));
            });

            this.adjustment.entityId.forEach(entity1 => {
              if (this.adjustment.adjustmentAccountPeriods.find(obj => obj.EntityId1 === entity1.id &&
                obj.PeriodId === period.Id && obj.AccountId === element.value) === undefined) {
                this.adjustment.adjustmentAccountPeriods.push(this.getNewAdjustmentAccountPeriodModel(element, period, entity1, null));
              }
            });

          }
        });
      }
    });


  }

  getNewAdjustmentAccountPeriodModel(element: any, period: PeriodModel, entity1: EntityModel, entity2: EntityModel) {
    const adjustmentAccountPeriod = new AdjustmentAccountPeriodModel;
    adjustmentAccountPeriod.Id = this.uniqueId++; // get random Id to prevent multiselect error, Id not required while Save/Edit
    adjustmentAccountPeriod.AccountId = element.value;
    adjustmentAccountPeriod.AccountName = element.value;
    adjustmentAccountPeriod.AccountNameTranslated = element.label;
    adjustmentAccountPeriod.PeriodId = period.Id;
    adjustmentAccountPeriod.Period = period.MonthYear;
    adjustmentAccountPeriod.PeriodTranslated = period.MonthYearTranslated;

    if (entity1 != null) {
      adjustmentAccountPeriod.EntityId1 = entity1.id;
      adjustmentAccountPeriod.Entity1Name = entity1.entityName;
    }

    if (entity2 != null) {
      adjustmentAccountPeriod.EntityId1 = entity2.parentEntityId;
      adjustmentAccountPeriod.Entity1Name = entity2.parentEntityName;

      adjustmentAccountPeriod.EntityId2 = entity2.id;
      adjustmentAccountPeriod.Entity2Name = entity2.entityName;
    }


    return adjustmentAccountPeriod;
  }

  cancel() {
    this.router.navigate(['engagement', this.engagementId, 'selectadjustment']);
  }

  amountChanged(amount: number) {
    if (!isNaN(amount)) {

      if (this.selectedEngagementAdjustment !== undefined && this.selectedEngagementAdjustment.length > 0) {
        this.selectedEngagementAdjustment.forEach((selectedAdj, indx) => {

          this.adjustment.adjustmentAccountPeriods.filter(x => x.Id === selectedAdj.Id).map((obj) => {
            obj.Amount = +amount;
          });

        });
      }
    }
  }
}
